import React, { useContext, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { appContext } from '@utils';
import { ActivityLogFilters } from './_/ActivityLogFilters/ActivityLogFilters';
import { ActivityLogTable } from './_/ActivityLogTable/ActivityLogTable';

export function ActivityLogPage() {
  const {
    activityLogStore: { open, reset },
  } = useContext(appContext);

  useEffect(() => {
    open();
    return () => reset();
  }, [open, reset]);

  return (
    <Box sx={{ width: '100%', p: 3 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Activity Log
      </Typography>
      <ActivityLogFilters />
      <ActivityLogTable />
    </Box>
  );
}
